import React from 'react';
import { clsx } from 'clsx';
import { Button } from 'src/components/ui/button';

const EmailReportBtn = () => {
  const handleReport = () => {};

  return (
    <Button
      variant="ghost"
      className={clsx(true && 'pointer-events-none opacity-50', 'flex gap-2 refresh-btn')}
      onClick={handleReport}
      disabled={true}
    >
      <p className="font-medium text-xs opacity-30">Schedule email report</p>
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.3">
          <path
            d="M16.5812 4.74202L9.71855 9.24515L2.73124 4.72259V13.3615H8.78649V15.1275H1.86562C1.63604 15.1275 1.41587 15.0345 1.25353 14.8689C1.0912 14.7033 1 14.4787 1 14.2445V1.88297C1 1.64879 1.0912 1.4242 1.25353 1.25862C1.41587 1.09303 1.63604 1 1.86562 1H17.4468C17.6764 1 17.8966 1.09303 18.0589 1.25862C18.2212 1.4242 18.3124 1.64879 18.3124 1.88297V8.06374H16.5812V4.74202ZM16.1493 2.76593H3.17358L9.70902 6.88233L16.1493 2.76593Z"
            fill="#05050D"
            stroke="white"
            strokeWidth="0.2"
          />
          <path
            d="M12.0878 14.7436C11.9751 14.2725 11.9751 13.7816 12.0878 13.3106L11.209 12.8046L12.0949 11.2753L12.9737 11.7813C13.3265 11.4484 13.7529 11.2028 14.2184 11.0643V10.0533H15.9902V11.0643C16.4615 11.2038 16.8867 11.4528 17.2349 11.7813L18.1137 11.2753L18.9996 12.8046L18.1208 13.3097C18.2334 13.7808 18.2334 14.2716 18.1208 14.7427L18.9996 15.2487L18.1137 16.778L17.2349 16.272C16.8821 16.6049 16.4557 16.8505 15.9902 16.989V18H14.2184V16.989C13.7529 16.8505 13.3265 16.6049 12.9737 16.272L12.0949 16.778L11.209 15.2487L12.0878 14.7436ZM15.1043 15.3511C15.4567 15.3511 15.7947 15.2115 16.0439 14.9632C16.2931 14.7148 16.4331 14.3779 16.4331 14.0266C16.4331 13.6754 16.2931 13.3385 16.0439 13.0901C15.7947 12.8417 15.4567 12.7022 15.1043 12.7022C14.7519 12.7022 14.4139 12.8417 14.1646 13.0901C13.9154 13.3385 13.7754 13.6754 13.7754 14.0266C13.7754 14.3779 13.9154 14.7148 14.1646 14.9632C14.4139 15.2115 14.7519 15.3511 15.1043 15.3511Z"
            fill="#05050D"
            stroke="white"
            strokeWidth="0.2"
          />
        </g>
      </svg>
    </Button>
  );
};

export default EmailReportBtn;
